module.exports = __webpack_public_path__ + "static/Zeugnis-8bbe5d79804b70059ddc8eb74df4e311.pdf";